var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLpCabinetProjectPriceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 6.25C22.3723 6.25 22.8492 6.44754 23.2008 6.79917C23.5525 7.15081 23.75 7.62772 23.75 8.125C23.75 8.62228 23.5525 9.09919 23.2008 9.45083C22.8492 9.80246 22.3723 10 21.875 10C21.3777 10 20.9008 9.80246 20.5492 9.45083C20.1975 9.09919 20 8.62228 20 8.125C20 7.62772 20.1975 7.15081 20.5492 6.79917C20.9008 6.44754 21.3777 6.25 21.875 6.25Z",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.46736 13.93C2.21361 15.33 2.18736 17.4425 3.33736 18.93C5.57112 21.8297 8.17013 24.4287 11.0699 26.6625C12.5574 27.8125 14.6699 27.7862 16.0699 26.5325C19.8543 23.1473 23.4104 19.5152 26.7149 15.66C27.0485 15.2765 27.2539 14.7984 27.3024 14.2925C27.5074 12.0475 27.9311 5.57997 26.1749 3.82497C24.4186 2.06997 17.9524 2.49247 15.7074 2.69872C15.2014 2.7472 14.7233 2.95261 14.3399 3.28622C10.4847 6.59024 6.85259 10.1459 3.46736 13.93Z",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2341 15.4587C17.2616 14.9562 17.4016 14.0399 16.6391 13.3424M16.6391 13.3424C16.3481 13.0896 16.0093 12.8979 15.6428 12.7787C14.0716 12.2249 12.1428 14.0774 13.5078 15.7737C14.2416 16.6862 14.8078 16.9662 14.7528 18.0012C14.7153 18.7287 14.0003 19.4899 13.0578 19.7799C12.2391 20.0324 11.3353 19.6987 10.7641 19.0599C10.0653 18.2799 10.1366 17.5449 10.1303 17.2249M16.6391 13.3424L17.4991 12.4824M10.8241 19.1574L10.0078 19.9737",
    stroke: "#FFD600",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpCabinetProjectPriceIcon);
export default __webpack_public_path__ + "static/media/lp_cabinet_project_price_icon.39f0b5367b3a84c4b757072a705e0ddf.svg";
export { ForwardRef as ReactComponent };